import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { MainWrapper } from 'modules/theme';
import { Spinner } from 'modules/common/components';
import { globalAction } from 'store/action';
import { globalStateSelector } from 'store/selector';
import { localStore } from './helpers';
import APIHandler from './modules/common/dataset/api';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import store from './store';
import { CommonPageHeader } from './modules/common/components';

import { ThemeNavigation } from 'modules/theme'; //used for other domain
import LayoutNavigation from './modules/layout/components/Navigation'; // used for portal
import { MainBarTheme } from 'modules/theme'; //used for other domain
import MainBarLayout from './modules/layout/components/MainBar'; // used for portal

import Cookies from 'universal-cookie';

const isPortal = process.env.REACT_APP_IS_PORTAL === "true";
const MainBar = !isPortal ? MainBarTheme : MainBarLayout;
const Navigation = !isPortal ? ThemeNavigation : LayoutNavigation;

export class PrivateRoutes extends Component {
  constructor(props) {
    super(props);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.redirectToOrganisation = this.redirectToOrganisation.bind(this);
    this.autheticatedRoute = this.autheticatedRoute.bind(this);
    // this.getCurrentUser = this.getCurrentUser.bind(this);
    // this.getOrganisation = this.getOrganisation.bind(this);
    this.errorShowAndLogout = this.errorShowAndLogout.bind(this);
    this.mApi = new APIHandler();
    this.state = {
      loading: true,
      error: ""
    };
  }
  redirectToLogin() {
    // let navigate = useNavigate(); 
    // navigate("/sign-in");
    // window.location = "/sign-in";

    return (
      <Redirect
        to={{ pathname: '/sign-in', state: { from: this.props.location } }}
      />
    );
  }
  redirectToOrganisation() {
    return (
      <Redirect
        to={{ pathname: '/organization', state: { from: this.props.location } }}
      />
    );
  }
  autheticatedRoute(Component, props) {
    return (
      <React.Fragment>
        <Provider store={store}>
          {/* <EventManager> */}
            <MainWrapper>
              <MainBar />
              <Navigation />
              {isPortal && <CommonPageHeader />}
              {/* <CommonPageHeader /> */}
              <Component {...props} />
              </MainWrapper>
          {/* </EventManager> */}
        </Provider>
      </React.Fragment>
    );
  }
  // async getCurrentUser() {
  //   const { dynamicUpdate } = this.props;
  //   // get organisation
  //   console.log(`[getCurrentUser] Started`);
  //   try {
  //     let user = await this.mApi.getCurrentUser();
  //     console.log(`[getCurrentUser] user`, user);
  //     if (user) {
  //       dynamicUpdate({ key: 'currentUser', value: user });
  //       dynamicUpdate({ key: 'loginToken', value: user._id });
  //       this.setState({ loading: false });
  //     } else {
  //       // check the case and logout user if needed
  //       this.errorShowAndLogout(`We didn't Found User Information`);
  //     }
  //   } catch (error) {
  //     this.errorShowAndLogout(`We didn't Found User Information`);
  //     console.log(`[getCurrentUser] error`, error);
  //   }
  // }

  async getProfile() {
    const { dynamicUpdate } = this.props;
    // get organisation
    console.log(`[getCurrentUser] Started`);
    try {
      let user = localStore.getItem("user");
      let loginToken = localStore.getItem("token");
      console.log(`[getCurrentUser] user`, user);
      if (user) {
        dynamicUpdate({ key: 'currentUser', value: JSON.parse(user) });
        dynamicUpdate({ key: 'loginToken', value: loginToken });
        this.setState({ loading: false });
      } else {
        // check the case and logout user if needed
        this.mApi.clearStorage();
      }
    } catch (error) {
      this.mApi.clearStorage();
      console.log(`[getCurrentUser] error`, error);
    }
  }
  // async getOrganisation(companyName) {
  //   const { dynamicUpdate } = this.props;
  //   // get organisation
  //   console.log(`[getOrganisation] Started`);
  //   try {
  //     let origanisation = await this.mApi.getCompany(companyName);
  //     if ( origanisation && origanisation.accessUrl ) {
  //       dynamicUpdate({ key: 'accessUrl', value: origanisation.accessUrl});
  //       dynamicUpdate({ key: 'socketUrl', value: origanisation.socketUrl || "" });
  //       dynamicUpdate({
  //         key: 'sipUrl',
  //         value: origanisation.cpassUrl || 'wss://cpaas-j.streamspace.ai'
  //       });
  //       if (
  //         origanisation.endPoints &&
  //         origanisation.endPoints[0] &&
  //         origanisation.endPoints[0].endPoint
  //       ) {
  //         dynamicUpdate({
  //           key: 'sipDomain',
  //           value: origanisation.endPoints[0].endPoint || ''
  //         });
  //       }
  //       this.mApi.updateUrl(origanisation.accessUrl, companyName);
  //       console.log(`[getOrganisation] done`, origanisation);
  //       this.getCurrentUser();
  //     } else {
  //       this.errorShowAndLogout(`Organisation Access URL not found`);
  //       console.error(`[getOrganisation] company not found`, origanisation );
  //     }
  //   } catch (error) {
  //     console.error(`[getOrganisation] error`, error);
  //     this.errorShowAndLogout(`Organisation Processing ERROR`);
  //   }
  // }
  errorShowAndLogout( msg ){
    let _this = this;
    this.mApi.clearStorage();
    this.setState({"error": msg || "We facing issue in login"})
    setTimeout(()=>{
      console.log("[errorShowAndLogout] Timeout Triggred")
      _this.redirectToLogin()
    },5000)
  }
  render() {
    const { component: Component, loginToken, ...rest } = this.props;
    const { error } = this.state;

    const cookies = new Cookies();
    const rcsToken = cookies.get("rcs-token");

    const isLoggedIn = localStore.getItem('token');

    return (
      <Route
        {...rest}
        exact
        render={props => {
          if( error ){
            return (
              <div className="row">
                <div className="col-md-12 text-center">
                  <h5>{error}</h5>
                </div>
              </div>
            )
          } else if ((!isPortal && isLoggedIn) || (rcsToken === isLoggedIn)) {
            // if (tenantName || pathname == '/organization') {
            //   if (pathname == '/organization') {
                if (this.state.loading) {
                  this.getProfile();
                  return <Spinner />;
                } else {
                  return this.autheticatedRoute(Component, props);
                }
            //     // return this.autheticatedRoute(Component, props);
            //   } else {
                // if (loginToken) {
                //   return this.autheticatedRoute(Component, props);
                // } else {
                //   return this.autheticatedRoute(Component, props);
                // }
              
          } else {
            return this.redirectToLogin();
          }
        }}
      />
    );
  }
}
PrivateRoutes.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  loginToken: globalStateSelector.getDynamic(state, { key: 'loginToken' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default withRouter(
  connect(stateToProps, dispatchToProps)(PrivateRoutes)
);



// WEBPACK FOOTER //
// ./src/PrivateRoutes.js